import React from "react";

const Shape = ({ position, dimension }) => {
  return (
    <div className="absolute z-10 hidden sm:block" style={position}>
      <div className="relative ">
        <div
          className="rounded-full border border-borderColor "
          style={{ width: `${dimension.first}`, height: `${dimension.first}` }}
        ></div>
        <div
          className="rounded-full border border-borderColor absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{
            width: `${dimension.second}`,
            height: `${dimension.second}`,
          }}
        ></div>
        <div
          className=" rounded-full border border-borderColor absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{ width: `${dimension.third}`, height: `${dimension.third}` }}
        ></div>
      </div>
    </div>
  );
};

export default Shape;
